import { AiOutlineLoading3Quarters } from "solid-icons/ai";
import { type Component, type ComponentProps, splitProps } from "solid-js";
import { cn } from "@/libs/cn";

export const Loading: Component<ComponentProps<"div">> = (props) => {
  const [style, rest] = splitProps(props, ["class", "classList"]);
  return (
    <div
      class={cn("flex items-center justify-center h-screen", style.class)}
      classList={style.classList}
      {...rest}
    >
      <AiOutlineLoading3Quarters
        class="animate-spin text-2xl w-10 h-10"
        size={40}
      />
    </div>
  );
};
